import React, { useState, Component, useEffect } from "react";
import useStyles from "./styles";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Link } from "@material-ui/core";

import AirportShuttleOutlinedIcon from "@material-ui/icons/AirportShuttleOutlined";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import AssignmentReturnIcon from "@material-ui/icons/AssignmentReturn";
import CancelScheduleSendIcon from "@material-ui/icons/CancelScheduleSend";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
//social icons
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import PinterestIcon from "@material-ui/icons/Pinterest";
import TwitterIcon from "@material-ui/icons/Twitter";
import YouTubeIcon from "@material-ui/icons/YouTube";

//importing files

// MUI Components
import {
  Typography,
  IconButton
} from "@material-ui/core";

export default function ProductDetails() {
  const classes = useStyles();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <div>
      <div className={classes.mainAboutusContainer}>
        <Breadcrumbs
          style={{ paddingTop: 20, paddingBottom: 10 }}
          aria-label="breadcrumb"
        >
          <Link className={classes.bCrumbLink} color="inherit" href="/">
            Home
          </Link>
          <Typography color="textPrimary">Contact us</Typography>
        </Breadcrumbs>

        <div className={classes.firstContainer}>
          <Typography variant="h5">Hi, How can we help you ?</Typography>
          <div
            className={classes.contactUsBoxesDiv}
          >
            <div className={classes.questionBox}>
              <Typography
                variant="p"
                color="primary"
                style={{ display: "flex", textTransform: "uppercase" }}
              >
                <AccountBalanceWalletIcon style={{ marginRight: 8 }} />I want to
                place an order?
              </Typography>
              <Typography
                variant="p"
                style={{ display: "flex", color: "grey", paddingTop: 15 }}
              >
                You can place an order by following steps given on place order
                page.
              </Typography>
            </div>

            <div className={classes.questionBox}>
              <Typography
                variant="p"
                color="primary"
                style={{ display: "flex", textTransform: "uppercase" }}
              >
                <AirportShuttleOutlinedIcon style={{ marginRight: 8 }} />I want
                to know where my order is ?
              </Typography>
              <Typography
                variant="p"
                style={{ display: "flex", color: "grey", paddingTop: 15 }}
              >
                Get status updates about your order with our Tracking Tool.
              </Typography>
            </div>

            <div className={classes.questionBox}>
              <Typography
                variant="p"
                color="primary"
                style={{ display: "flex", textTransform: "uppercase" }}
              >
                <MonetizationOnIcon style={{ marginRight: 8 }} />I want to sell
                on digimart
              </Typography>
              <Typography
                variant="p"
                style={{ display: "flex", color: "grey", paddingTop: 15 }}
              >
                Go to signup seller page and register your store by providing
                necessary details.
              </Typography>
            </div>
          </div>

          <div
            className={classes.contactUsBoxesDiv}
          >
            <div className={classes.questionBox}>
              <Typography
                variant="p"
                color="primary"
                style={{ display: "flex", textTransform: "uppercase" }}
              >
                <AssignmentReturnIcon style={{ marginRight: 8 }} />I want to
                return an order?
              </Typography>
              <Typography
                variant="p"
                style={{ display: "flex", color: "grey", paddingTop: 15 }}
              >
                You can return an order by following steps given on return order
                page.
              </Typography>
            </div>

            <div className={classes.questionBox}>
              <Typography
                variant="p"
                color="primary"
                style={{ display: "flex", textTransform: "uppercase" }}
              >
                <QuestionAnswerIcon style={{ marginRight: 8 }} />I want to chat
                with seller ?
              </Typography>
              <Typography
                variant="p"
                style={{ display: "flex", color: "grey", paddingTop: 15 }}
              >
                Go to seller's store page and click on chat button to chat with
                seller.
              </Typography>
            </div>

            <div className={classes.questionBox}>
              <Typography
                variant="p"
                color="primary"
                style={{ display: "flex", textTransform: "uppercase" }}
              >
                <CancelScheduleSendIcon style={{ marginRight: 8 }} />I want to
                cancel an order
              </Typography>
              <Typography
                variant="p"
                style={{ display: "flex", color: "grey", paddingTop: 15 }}
              >
                Signin from your account and cancel order by clicking on orders
                button.
              </Typography>
            </div>
          </div>

          <div
            style={{ display: "flex", flexDirection: "column", paddingTop: 15 }}
          >
            <Typography variant="p">I have another question</Typography>
            <Link href="/">Browse more Frequently asked questions</Link>
          </div>
        </div>

        {/* Conatct us Info coatainer */}
        <div className={classes.secondConatiner}>
          <Typography variant="h5">Contact us</Typography>
          <div
            style={{
              paddingTop: 25,
              justifyContent: "space-between",
            }}
          >
            <div className={classes.imagecover}>
              <div className={classes.layer}></div>
            </div>

            <div style={{ marginTop: 20 }}>
              <Typography>
                For order status please <Link href="/">click here</Link>
              </Typography>
              <Typography>
                To Place order <Link href="/">Login</Link> from your account
              </Typography>
              <Typography>
                For other inquires feel free to email us on{" "}
                <Link href="/">digimart.cui@gmail.com</Link>
              </Typography>
              <Typography
                variant="h5"
                style={{ fontWeight: "bold", paddingTop: 15 }}
              >
                Email
              </Typography>
              <Typography variant="h6">digimart.cui@gmail.com</Typography>
              <Typography
                variant="h5"
                style={{ fontWeight: "bold", paddingTop: 15 }}
              >
                Contact Number
              </Typography>
              <Typography variant="h6">051-09876543</Typography>

              <Typography
                variant="h5"
                style={{ fontWeight: "bold", paddingTop: 15 }}
              >
                Address
              </Typography>
              <Typography variant="h6">
                AZ plaza, Ground floor, near comsats university, Islamabad
              </Typography>

              <Typography
                variant="h5"
                style={{ fontWeight: "bold", paddingTop: 15 }}
              >
                Social
              </Typography>
              <div className={classes.Icons}>
                <IconButton style={{ padding: 3 }}>
                  <FacebookIcon />
                </IconButton>
                <IconButton>
                  <InstagramIcon />
                </IconButton>
                <IconButton>
                  <PinterestIcon />
                </IconButton>
                <IconButton>
                  <TwitterIcon />
                </IconButton>
                <IconButton>
                  <YouTubeIcon />
                </IconButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
